import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';

const Pricing = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen">
      <Navbar />
      <div className="bg-gray-50 py-12 sm:py-16 lg:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center">
          <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl lg:text-5xl">
            Simple, Transparent Pricing
          </h2>
          <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto">
            Start building your board game community for free. More plans coming soon!
          </p>
        </div>

        {/* Pricing Card */}
        <div className="mt-12 lg:mt-16 max-w-lg mx-auto">
          <div className="relative rounded-2xl border-2 border-indigo-600 bg-white shadow-xl">
            {/* Popular Badge */}
            <div className="absolute -top-5 left-0 right-0 mx-auto w-32">
              <div className="rounded-full bg-gradient-to-r from-indigo-600 to-purple-600 px-3 py-1 text-sm font-semibold text-white text-center shadow-md">
                Current Plan
              </div>
            </div>

            <div className="p-8 sm:p-10">
              {/* Plan Name */}
              <h3 className="text-center">
                <span className="inline-flex items-center justify-center px-3 py-1 rounded-full text-sm font-medium bg-indigo-100 text-indigo-800">
                  Free Forever
                </span>
              </h3>

              {/* Price */}
              <div className="mt-6 flex items-baseline justify-center">
                <span className="text-5xl font-extrabold tracking-tight text-gray-900">$0</span>
                <span className="ml-1 text-2xl font-medium text-gray-500">/month</span>
              </div>

              <p className="mt-4 text-center text-gray-500">
                Everything you need to create and manage your board game club
              </p>

              {/* Features List */}
              <ul className="mt-8 space-y-4">
                <li className="flex items-start">
                  <div className="flex-shrink-0">
                    <svg className="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <p className="ml-3 text-base text-gray-700">
                    Create unlimited clubs
                  </p>
                </li>
                <li className="flex items-start">
                  <div className="flex-shrink-0">
                    <svg className="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <p className="ml-3 text-base text-gray-700">
                    Manage board games inventory
                  </p>
                </li>
                <li className="flex items-start">
                  <div className="flex-shrink-0">
                    <svg className="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <p className="ml-3 text-base text-gray-700">
                    Accept bookings from members
                  </p>
                </li>
                <li className="flex items-start">
                  <div className="flex-shrink-0">
                    <svg className="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <p className="ml-3 text-base text-gray-700">
                    Custom club profiles with images
                  </p>
                </li>
                <li className="flex items-start">
                  <div className="flex-shrink-0">
                    <svg className="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <p className="ml-3 text-base text-gray-700">
                    Public club listings
                  </p>
                </li>
                <li className="flex items-start">
                  <div className="flex-shrink-0">
                    <svg className="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <p className="ml-3 text-base text-gray-700">
                    Member management
                  </p>
                </li>
                <li className="flex items-start">
                  <div className="flex-shrink-0">
                    <svg className="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <p className="ml-3 text-base text-gray-700">
                    Email notifications
                  </p>
                </li>
                <li className="flex items-start">
                  <div className="flex-shrink-0">
                    <svg className="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <p className="ml-3 text-base text-gray-700">
                    Community support
                  </p>
                </li>
              </ul>

              {/* CTA Button */}
              <div className="mt-10">
                <button
                  onClick={() => navigate('/register')}
                  className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 md:py-4 md:text-lg md:px-10 transition-colors shadow-lg hover:shadow-xl"
                >
                  Get Started Free
                </button>
              </div>

              <p className="mt-4 text-xs text-center text-gray-500">
                No credit card required • Set up in minutes
              </p>
            </div>
          </div>
        </div>

        {/* Coming Soon Section */}
        <div className="mt-16 text-center">
          <h3 className="text-2xl font-bold text-gray-900">
            More Plans Coming Soon
          </h3>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto">
            We're working on premium plans with advanced features like analytics, 
            custom branding, priority support, and more. Stay tuned!
          </p>
          
          {/* Feature Cards */}
          <div className="mt-12 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3 max-w-5xl mx-auto">
            <div className="bg-white rounded-lg shadow-md p-6 border border-gray-200">
              <div className="flex items-center justify-center h-12 w-12 rounded-md bg-purple-100 text-purple-600 mx-auto">
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                </svg>
              </div>
              <h4 className="mt-4 text-lg font-medium text-gray-900">Advanced Analytics</h4>
              <p className="mt-2 text-sm text-gray-500">
                Track attendance, game popularity, and member engagement
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-md p-6 border border-gray-200">
              <div className="flex items-center justify-center h-12 w-12 rounded-md bg-indigo-100 text-indigo-600 mx-auto">
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01" />
                </svg>
              </div>
              <h4 className="mt-4 text-lg font-medium text-gray-900">Custom Branding</h4>
              <p className="mt-2 text-sm text-gray-500">
                Use your own logo, colors, and custom domain
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-md p-6 border border-gray-200">
              <div className="flex items-center justify-center h-12 w-12 rounded-md bg-green-100 text-green-600 mx-auto">
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z" />
                </svg>
              </div>
              <h4 className="mt-4 text-lg font-medium text-gray-900">Priority Support</h4>
              <p className="mt-2 text-sm text-gray-500">
                Get help faster with dedicated support channels
              </p>
            </div>
          </div>
        </div>

        {/* FAQ Section */}
        <div className="mt-16 border-t border-gray-200 pt-16">
          <h3 className="text-2xl font-bold text-gray-900 text-center">
            Frequently Asked Questions
          </h3>
          <dl className="mt-10 space-y-8 max-w-3xl mx-auto">
            <div>
              <dt className="text-lg font-medium text-gray-900">
                Is the free plan really free forever?
              </dt>
              <dd className="mt-2 text-base text-gray-600">
                Yes! We believe in supporting the board game community. The free plan includes all core features and will always be available.
              </dd>
            </div>
            <div>
              <dt className="text-lg font-medium text-gray-900">
                Can I upgrade to a paid plan later?
              </dt>
              <dd className="mt-2 text-base text-gray-600">
                Absolutely! Once we launch our premium plans, you'll be able to upgrade at any time. All your data will be preserved.
              </dd>
            </div>
            <div>
              <dt className="text-lg font-medium text-gray-900">
                How many clubs can I create?
              </dt>
              <dd className="mt-2 text-base text-gray-600">
                With the free plan, you can create and manage unlimited clubs. There are no restrictions on the number of clubs you can run.
              </dd>
            </div>
            <div>
              <dt className="text-lg font-medium text-gray-900">
                Do you offer refunds?
              </dt>
              <dd className="mt-2 text-base text-gray-600">
                Since the current plan is free, refunds don't apply. For future paid plans, we'll have a fair refund policy.
              </dd>
            </div>
          </dl>
        </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Pricing;
